import type { NotificationData } from '@mantine/notifications';
import { ReactNode } from 'react';

enum NotificationType {
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}

// Extend Mantine's NotificationData with our custom type system
type NotificationConfig = Omit<NotificationData, 'message'> & {
  message: string; // Make message required and always a string (not ReactNode)
  type: NotificationType; // Use our custom enum instead of generic
};

type NotificationMethod = (message: string, title?: string, options?: Partial<NotificationConfig>) => string;
type NotificationModalHandler = (
  title: string | ReactNode | undefined,
  message: string,
  type?: NotificationType,
) => void;

type NotificationContextType = {
  showNotification: (config: NotificationConfig) => string;
  hideNotification: (id: string) => void;
  showFullTextModal: (title: string | undefined, message: string, type?: NotificationType) => void;
};

export { NotificationType };
export type { NotificationConfig, NotificationContextType, NotificationMethod, NotificationModalHandler };
